// @flow

import moment from 'moment';
import orderBy from 'lodash/orderBy';
import get from 'lodash/get';
import { getFullName } from 'clark-utils';
import { getSessionWageInCents } from 'utils/helpers/sessions';

import type { SessionType } from 'types/sessions';
import type { ClientType, ClientsType } from 'types/clients';

export const orderedPastSessions = (sessions: SessionType[]): SessionType[] =>
  orderBy(sessions, 'attributes.startTime', 'desc');

export const orderedFutureSessions = (sessions: SessionType[]): SessionType[] =>
  orderBy(sessions, 'attributes.startTime', 'asc');

export const getSessionsDataObject = (clients: ClientsType, session: SessionType) => {
  const {
    id: sessionId,
    attributes: { startTime, status },
    relationships: {
      client: {
        data: { id: clientId },
      },
    },
  } = session;

  const formattedStartTime = moment(startTime).format('MMM Do [at] hA');

  const associatedClient = clients[clientId];
  const clientName = getFullName(associatedClient.attributes) || 'Unknown Client';

  const sessionWageInCents = getSessionWageInCents(session);

  return {
    sessionId,
    status,
    clientName,
    sessionWageInCents,
    formattedStartTime,
  };
};

const getFirstLastInitial = (client: ?ClientType): string =>
  client
    ? `${client.attributes.firstName}${
        client.attributes.lastName.charAt(0) ? ` ${client.attributes.lastName.charAt(0)}.` : ''
      }`
    : 'Unknown Client';

export const transformTutorSessionsToCalendarEvents = (
  sessions: SessionType[],
  clients: ClientsType,
): Object[] =>
  sessions.map(({ id, attributes: { startTime, endTime, status, locationRaw }, relationships }) => {
    const client = clients[get(relationships, 'client.data.id')];

    return {
      start: new Date(startTime),
      end: new Date(endTime),
      id,
      title: getFirstLastInitial(client),
      status,
      locationRaw,
    };
  });



// WEBPACK FOOTER //
// ./src/components/sessions/list/helpers.js